import { makeStyles } from '@material-ui/core';

export const AGENTS_CONTAINER_CLASS = 'matchingAgentsContainer';
export const MORE_AGENTS_ICON_CLASS = 'moreAgentsIcon';

export const useDetailStyles = makeStyles(() => ({
    radioWrapper: {
        margin: '8px 0',

        '& .MuiFormControlLabel-root': {
            marginTop: 0,
        },
    },
    testSelect: {
        marginRight: '8px',

        '& .MuiSelect-select': {
            minWidth: 390,
        },
    },
    selectionError: {
        color: '#BF3D56',
    },
    postRow: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr auto',
        columnGap: 24,
        alignItems: 'center',
        marginBottom: 20,
    },
    actionButton: {
        width: 48,
        height: 48,
        backgroundColor: '#4f6f84',
        color: '#fff',
        '&:hover': {
            backgroundColor: '#3f5e71',
        },
    },
    headerRow: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr auto',
        columnGap: 24,
        alignItems: 'center',
        marginBottom: 20,
    },
}));

export const useResultStyles = makeStyles((theme) => ({
    responseTimeBarComponent: {
        float: 'left',
        height: 14,
        transition: 'width 2s',
    },
    dnsDelay: {
        backgroundColor: '#67DC6A !important',
        color: '#000',
    },
    avgDns: {},
    networkDelay: {
        backgroundColor: '#7F6FC5 !important',
        color: '#000',
    },
    avgNetwork: {},
    sslDelay: {
        backgroundColor: '#FF69B4 !important',
        color: '#000',
    },
    avgSsl: {},
    clientDelay: {
        backgroundColor: '#FFC833 !important',
        color: '#000',
    },
    avgClient: {},
    appDelay: {
        backgroundColor: '#5BA3CA !important',
        color: '#000',
    },
    avgApp: {},
    serverDelay: {
        backgroundColor: '#FF7943 !important',
        color: '#000',
    },
    avgServer: {},
    tabContent: {
        paddingTop: '10px',
    },
    printHiddenTabs: {
        display: 'none !important',
    },
    printTabHeader: {
        display: 'block',
        whiteSpace: 'nowrap',
        fontSize: '16px',
        fontWeight: 100,
        borderBottom: '#ddd solid 1px',
        width: '100%',
        padding: '10px',
    },
    printTabSection: {
        marginTop: '10px',
        '&:first-child': {
            marginTop: 0,
        },
    },
    scrollX: {
        overflowX: 'auto',
    },

    fadeOnHoverTrigger: {
        '&:hover $fadeOnHover': {
            opacity: 1,
        },
    },
    fadeOnHover: {
        transitionProperty: 'opacity',
        transitionDuration: '0.2s',
        transitionTimingFunction: 'ease',
        opacity: 0,
    },
    static: {
        ...theme.mixins.flex.grow(0),
        ...theme.mixins.flex.shrink(0),
    },
    grow: {
        ...theme.mixins.flex.grow(1),
        ...theme.mixins.flex.shrink(1),
        ...theme.mixins.flex.basis('50%'),
    },
    topLine: {
        ...theme.mixins.flex.displayFlex,
        width: '100%',
        paddingBottom: theme.spacing(1),
    },
    title: {
        fontSize: 14,
        fontWeight: 'bold',
        paddingBottom: 12,
    },
    titleWrapper: {
        display: 'flex',
        flexFlow: 'row wrap',
        textAlign: 'center',
    },
    titleAndUrl: {
        textAlign: 'left',
    },
    table: {
        width: '100%',
        display: 'table',
        tableLayout: 'fixed',

        fontSize: '20px',
        fontWeight: '500',
        textAlign: 'center',
    },
    tableCell: {
        display: 'table-cell',
        verticalAlign: 'middle',
        textOverflow: 'ellipsis',
        whiteApace: 'nowrap',
        overflow: 'hidden',
    },
    url: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    aside: {
        width: '20%',
        fontSize: '16px',
        fontWeight: '100',
    },
    linkContainer: {
        ...theme.mixins.flex.displayFlex,
        ...theme.mixins.flex.justifyContentFlexEnd,
        ...theme.mixins.flex.grow(1),

        '& .MuiIconButton-root': {
            marginRight: theme.spacing(1),

            '&:hover': {
                background: 'none',
            },
        },
    },
    fakeLinkButton: {
        height: '40px',
        padding: theme.spacing(1),
    },
    '@keyframes fadeIn': {
        from: { opacity: 0 },
        to: { opacity: 1 },
    },
    linkButton: {
        ...theme.mixins.flex.displayFlex,
        ...theme.mixins.flex.alignItemsCenter,
        color: theme.palette.text.primary,
        textTransform: 'uppercase',
        borderRadius: 4,
        padding: theme.spacing(1),
        animation: '$fadeIn 1s',

        '& svg': {
            fill: theme.palette.text.secondary,
        },

        '&:hover': {
            textDecoration: 'none',
            background: theme.palette.action.hover,
        },
    },
}));

export const useColumnStyles = makeStyles((theme) => ({
    root: {
        [`& .${AGENTS_CONTAINER_CLASS}`]: {
            ...theme.mixins.flex.displayFlex,
            ...theme.mixins.flex.flexDirectionRow,
            ...theme.mixins.flex.alignItemsCenter,
            [`& .${MORE_AGENTS_ICON_CLASS}`]: {
                paddingLeft: 10,
                '& svg': {
                    ...theme.mixins.flex.displayFlex,
                    ...theme.mixins.flex.alignItemsCenter,
                    fontSize: 18,
                },
            },
        },
    },
}));
